export const expireTime = function (et) {       //将时间戳装换为yyyy-MM-dd hh:mm:ss
    let d = new Date(et)
    let yyyy = d.getFullYear();
    let MM = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
    let dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
    let hh = d.getHours() >= 10 ? d.getHours() : '0' + d.getHours();
    let mm = d.getMinutes() >= 10 ? d.getMinutes() : '0' + d.getMinutes();
    let ss = d.getSeconds() >= 10 ? d.getSeconds() : '0' + d.getSeconds();
    return yyyy + "-" + MM + "-" + dd + " " + hh + ":" + mm + ":" + ss
}

export const trueTime = function (et) {       //将时间戳装换为yyyy.MM.dd 
    let d = new Date(et)
    let yyyy = d.getFullYear();
    let MM = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
    let dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
    return yyyy + "." + MM + "." + dd
}

export const trueTime2 = function (et) {       //将时间戳装换为yyyy-MM-dd 
    let d = new Date(et)
    let yyyy = d.getFullYear();
    let MM = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
    let dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
    return yyyy + "-" + MM + "-" + dd
}

export const switchTime = function (et) {       //将yyyy.MM.dd 装换为yyyy-MM-dd 
    let d = new Date(et)
    let yyyy = d.getFullYear();
    let MM = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
    let dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
    return yyyy + "-" + MM + "-" + dd
}


export const nowDate = function () {       //获取当前时间,格式为yyyy-MM-dd 
    let d = new Date()
    let yyyy = d.getFullYear();
    let MM = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
    let dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
    return yyyy + "-" + MM + "-" + dd
}

export const fisrtDay = function () {       //获取当月第一天,格式为yyyy-MM-dd 
    let d = new Date()
    let yyyy = d.getFullYear();
    let MM = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
    let dd = "01"
    return yyyy + "-" + MM + "-" + dd
}

export const compareDate = function (startD, endD) {       //判断时间先后关系 
    let d1 = Date.parse(new Date(startD))
    let d2 = Date.parse(new Date(endD))
    if (d2 - d1 > 0) {
        return true
    } else {
        return false
    }
}

export const spaceDate = function (startD, endD) {       //判断时间间隔的天数 
    let d1 = Date.parse(new Date(startD))
    let d2 = Date.parse(new Date(endD))
    return d1 - d2;
}

/**
  * @name  时间日期的相关操作
*/
// 时间戳转为 xxxx-xx-xx 格式
export const formatDate =(timeStamp, type) => {
    let d = new Date(timeStamp)
    let yyyy = d.getFullYear();
    let MM = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
    let dd = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
    let hh = d.getHours() >= 10 ? d.getHours() : '0' + d.getHours();
    let mm = d.getMinutes() >= 10 ? d.getMinutes() : '0' + d.getMinutes();
    let ss = d.getSeconds() >= 10 ? d.getSeconds() : '0' + d.getSeconds();
    switch (type) {
        case 'xxxx-xx-xx':
            return `${yyyy}-${MM}-${dd}`;
            
        case 'xxxx.xx.xx':
            return `${yyyy}.${MM}.${dd}`;
            
        case 'xxxx-xx-xx xx:xx:xx':
            return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
            
        case 'xxxx.xx.xx xx:xx:xx':
            return `${yyyy}.${MM}.${dd} ${hh}:${mm}:${ss}`;
    }
};






// export const ls=function(key,value){
// 	var curTime = new Date().getTime();
// 	localStorage.setItem(key,JSON.stringify({data:value,time:curTime}));
// }

// export const lg=function(key,exp){
// 	 	var data = localStorage.getItem(key);
// 	var dataObj = JSON.parse(data);
//  	if (new Date().getTime() - dataObj.time>exp) {
// 		console.log('信息已过期')
//  	}else{
//  		//console.log("data="+dataObj.data);
// 		//console.log(JSON.parse(dataObj.data));
//  		var dataObjDatatoJson = JSON.parse(dataObj.data)
//  		return dataObjDatatoJson;
//  	}
// }

export const setLStorage = function (key, value) {
    if (!key) return;
    if (typeof (value) === 'object') {
        window.localStorage.setItem(key, JSON.stringify(value));
    } else {
        window.localStorage.setItem(key, value);
    }

}

export const getLStorage = function (key) {
    if (!key) return;
    return window.localStorage.getItem(key);
}


// 防抖
export const debounce = (fn, delay) => {

    var delay = delay || 200;
    var timer;
    return function () {
        var th = this;
        var args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            timer = null;
            fn.apply(th, args);
        }, delay);
    };
}
// 节流
export function throttle(fn, interval) {
    var last;
    var timer;
    var interval = interval || 200;
    return function () {
        var th = this;
        var args = arguments;
        var now = +new Date();
        if (last && now - last < interval) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                last = now;
                fn.apply(th, args);
            }, interval);
        } else {
            last = now;
            fn.apply(th, args);
        }
    }
}

export function random(num) {
    var code = "";
    for (var i = 0; i < num; i++) {
        var radom = Math.floor(Math.random() * 10);
        code += radom;
    }

    return code;

}

/**
 * 验证是否是PC端
 * @param str 字符串
 * @return bool
 */
export const isPC = function () {
    var result = true;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) result = false;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return result;
}



// WEBPACK FOOTER //
// ./src/utils/util.js